module.exports = __webpack_public_path__ + "img/oss-detail.bf9bfedd.png";